import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../services/apiService";
import { useCarContext } from "../CarContext";
import { Loading } from "../components/Loading";
import { Button, ImageWithFallback } from "../components/Utilities";
import locCard from "../assets/locCard.svg";
import rc_yes from "../assets/rc-yes.svg";
import rc_no from "../assets/rc-no.svg";
import smallcar from "../assets/smallcar.svg";
import dummyImg from "../assets/dummyImg.svg";
import { UploadModal } from "../components/ModelOverlay/UploadPicturesModel";
import { formatOwnership } from "../DealerHome";
import Header from "../components/Header";
import "./evaluatorHome.css";
import { formatTimeLeft } from "../MyCars/Inspection";
import imgTop from "../assets/imgTop.png";
import imgBottom from "../assets/imgBottom.png";
import rightArrow from "../assets/rightslide.svg";
import dummy_top from "../assets/dummy_top.svg";
import dummy_footer from "../assets/dummy_footer.svg";
import logo from "../assets/trustauto-logo.png";
import dummyBody from "../assets/dummybody.svg";
import { LiveTimer } from "../components/CardLayout";

// === FULL CAR CARD CODE PASTED HERE (NO REUSE) ===
const EvaluatorCarCard = ({
  car,
  onCarSelect,
  onSlideRight,
  onSlideLeft,
  isFourth,
  hasMoreCars,
  index,
}) => {
  const navigate = useNavigate();

  if (car.isDummy) {
    return (
      <div className={`car-card dummy`}>
        <div className={`dummy-layout ${index % 2 === 1 ? "dummy-layout-alt" : ""}`}>
          <div className="dummy-header">
            <img src={dummy_top} alt="" className="dummyTop" />
            <img src={logo} alt="" className="dummyLogo" />
          </div>
          <div className="dummy-body">
            <div className={`dummy_words ${index % 2 === 1 ? "dummy_words-alt" : ""}`}>
              <p>INDIA’S LEADING B2B USED CAR MARKETPLACE</p>
            </div>
            <Button
              onClick={() => navigate("https://www.trustauto.in")}
              className={`dummy-button ${index % 2 === 1 ? "dummy-button-alt" : ""}`}
            >
              Know More
            </Button>
          </div>
          <div className="dummy-footer">
            <img src={dummy_footer} alt="" className="dummyBottom" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`car-card ${car.isSold ? "sold" : ""}`}
      onClick={() => onCarSelect(car)}
    >
      {/* SOLD Overlay */}
      {car.isSold && (
        <div className="sold-overlay">
          <div className="sold-badge">
            <span className="sold-text">SOLD</span>
          </div>
        </div>
      )}

      <div className="car-image-wrapper">
        <img src={imgTop} className="imgTop" alt="" />
        <img src={imgBottom} className="imgBottom" alt="" />
        <ImageWithFallback
          src={car.image}
          alt={`${car.brand} ${car.model}`}
          className="car-image"
        />
        <LiveTimer startDateStr={car.startDate} endDateStr={car.endDate} />
        <div className="car-location">
          <ImageWithFallback src={locCard} alt="Location" />
          <p className="car-location-name">{car.location}</p>
        </div>
      </div>

      <div className="car-details">
        <div className="car-info">
          <h3 className="car-title">
            {car.year} {car.brand} {car.model}
          </h3>
          <div className="car-spec-container">
            <div className="car-specs">
              <span className="distance">
                {car.rc ? (
                  <img src={rc_yes} alt="" className="rc" />
                ) : (
                  <img src={rc_no} alt="" className="rc" />
                )}
                {car.km.toLocaleString()} kms
              </span>
              <span className="car-fuel">
                {" • "}
                {car.fuel} • {car.transmission}
              </span>
            </div>
            <div className="car-tags">
              {car.rc ? (
                <img src={rc_yes} alt="" className="rc" />
              ) : (
                <img src={rc_no} alt="" className="rc" />
              )}
              <span className="rto-tag">{car.rto}</span>
              <span className="owner-tag">{car.owner}</span>
            </div>
            <div className="phone-car-location">
              <ImageWithFallback src={locCard} alt="Location" />
              <p className="car-location-name">{car.location}</p>
            </div>
          </div>
        </div>

        {/* === UPLOAD / VIEW PICTURES BUTTON === */}
        <div className="car-actions">
          <Button
            className="btn-full"
            variant="primary"
            onClick={(e) => {
              e.stopPropagation();
              onCarSelect(car);
            }}
          >
            {car.state === "EVALUATION_COMPLETE" ? "View Pictures" : "Upload Pictures"}
          </Button>
        </div>
      </div>

      {/* Slide Buttons */}
      {isFourth && hasMoreCars && (
        <>
          <button
            className="left-slide-button"
            onClick={(e) => {
              e.stopPropagation();
              onSlideLeft(car.yard || "Unknown Yard");
            }}
          >
            <img src={rightArrow} alt="Slide Left" className="left-slide-icon" />
          </button>
          <button
            className="right-slide-button"
            onClick={(e) => {
              e.stopPropagation();
              onSlideRight(car.yard || "Unknown Yard");
            }}
          >
            <img src={rightArrow} alt="Slide Right" className="right-slide-icon" />
          </button>
        </>
      )}
    </div>
  );
};

// === LOCATION CARD (UNCHANGED) ===
const LocationCard = ({ yard, yardCars, carCount, yardMap }) => {
  const yardLocation = yardCars[0]?.location || yard || "Unknown Yard";

  return (
    <div className="car-card location-card">
      <div className="location-column">
        <div className="car-count-heading">
          <ImageWithFallback src={smallcar} alt="Car" className="small-car-icon" />
          <span className="car-count"> {carCount}</span>
        </div>
        <div className="location-heading">
          <img src={locCard} alt="Location" className="location-img" />
          <p className="location-title">{yardLocation}</p>
        </div>

        <div
          className="container-map"
          onClick={() => window.open(getMapUrl(yardMap), "_blank")}
        >
          <div
            className="yard-map-container"
            dangerouslySetInnerHTML={{
              __html:
                buildCleanMapIframe(yardMap) ||
                '<div style="background:#f0f0f0; height:200px; display:flex; align-items:center; justify-content:center; color:#999; font-size:14px;">Map not available</div>',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export const EvaluatorHome = () => {
  const navigate = useNavigate();
  const { setUploadPicturesCount } = useCarContext();
  const [cars, setCars] = useState([]);
  const [yardMapData, setYardMapData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedCarId, setSelectedCarId] = useState(null);
  const carGridRefs = useRef({});

  // Fetch + Extract YardMap
  useEffect(() => {
    const fetchCars = async () => {
      try {
        setLoading(true);
        const response = await apiService.getEvaluatorCars();
        const yardGroups = response.data?.yardGroups || [];

        const extractedYardMaps = {};
        yardGroups.forEach((group) => {
          if (group.YardMap) extractedYardMaps[group.yard] = group.YardMap;
        });
        setYardMapData(extractedYardMaps);

        const validCars = yardGroups
          .flatMap((g) => g.cars || [])
          .map((car) => ({
            id: car.id || `eval-${Math.random().toString(36).substr(2, 9)}`,
            car_id: car.car_id,
            brand: car.make || "Unknown",
            model: car.model || "Unknown",
            rto: car.regno || "N/A",
            flowEntityId: car.flowEntityId || car.id,
            fuel: car.fueltype || "Unknown",
            transmission: car.transmission || "N/A",
            year: Number(car.year) || 0,
            km: Number(car.kmsrun) || 0,
              startDate: car.evaluationStartedAt,
            endDate: car["ta-end-date"] || car.ta_end_date,
            image: car.car_image_urls?.[0] || "https://via.placeholder.com/150",
            timeLeft: car.ta_end_date ? formatTimeLeft(car.ta_end_date) : "N/A",
            location: car.yard || "Unknown",
            rc: car.rcstatus === "Yes",
            owner: formatOwnership(car.ownership),
            yard: car.yard || "Unknown",
            state: car.state || "EVALUATION",
            evaluationImages: car.evaluationImages || [],
          }));

        setCars(validCars);
        setUploadPicturesCount(validCars.length);
        setLoading(false);
      } catch (err) {
        setError("Failed to load cars.");
        setLoading(false);
      }
    };
    fetchCars();
  }, [setUploadPicturesCount]);

  // Group by Yard
  const groupedByYard = cars.reduce((acc, car) => {
    const yard = car.yard || "Unknown Yard";
    acc[yard] = acc[yard] || [];
    acc[yard].push(car);
    return acc;
  }, {});

  const handleUploadPictures = (car) => {
    setSelectedCarId(car.id);
    setIsUploadModalOpen(true);
  };

  const handleSubmitPictures = (carId, images) => {
    setCars((prev) =>
      prev.map((c) =>
        c.id === carId
          ? { ...c, evaluationImages: images, state: images.length > 0 ? "EVALUATION_COMPLETE" : "EVALUATION" }
          : c
      )
    );
  };

  const handleCloseModal = () => {
    setIsUploadModalOpen(false);
    setSelectedCarId(null);
  };

  const handleSlideLeft = (yard, view) => {
    const ref = carGridRefs.current[`${view}-${yard}`];
    if (ref) ref.scrollBy({ left: -(240 + 24) * 4, behavior: "smooth" });
  };

  const handleSlideRight = (yard, view) => {
    const ref = carGridRefs.current[`${view}-${yard}`];
    if (ref) ref.scrollBy({ left: (240 + 24) * 4, behavior: "smooth" });
  };

  return (
    <div className="my-cars evahome">
      <Header />
      <div className="container">
      <div className="content-wrapper">
        <div className="main-content">

          {/* WEB VIEW */}
          <div className="web-view">
            {loading && <Loading />}
            {error && <div className="error">{error}</div>}
            {cars.length === 0 && !loading && (
              <div className="no-results">
                <h3>No cars to evaluate</h3>
                {/* <Button variant="primary" onClick={() => navigate("/DealerHome")}>
                  Back to Home
                </Button> */}
              </div>
            )}

            {Object.entries(groupedByYard).map(([yard, yardCars]) => {
              const carCount = yardCars.length;
              const firstFour = yardCars.slice(0, 4);
              const rest = yardCars.slice(4);
              const dummies = Array(Math.max(0, 4 - firstFour.length)).fill().map((_, i) => ({
                id: `dummy-${yard}-${i}`,
                isDummy: true,
                image: dummyImg,
              }));
              const displayCars = [...firstFour, ...dummies, ...rest];

              return (
                <div className="card-slider" key={yard}>
                  <div className="yard-group">
                    <div className="car-grid-wrapper">
                      <div
                        className="car-grid"
                        ref={(el) => (carGridRefs.current[`web-${yard}`] = el)}
                      >
                        {displayCars.map((car, idx) => (
                          <EvaluatorCarCard
                            key={car.id}
                            car={car}
                            onCarSelect={handleUploadPictures}
                            onSlideLeft={() => handleSlideLeft(yard, "web")}
                            onSlideRight={() => handleSlideRight(yard, "web")}
                            isFourth={idx === 3}
                            hasMoreCars={displayCars.length > 4}
                            index={idx}
                          />
                        ))}
                      </div>
                      <LocationCard
                        yard={yard}
                        yardCars={yardCars}
                        carCount={carCount}
                        yardMap={yardMapData[yard]}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* MOBILE VIEW */}
          <div className="mobile-view">
            {loading && <Loading />}
            {error && <div className="error">{error}</div>}
            {cars.length === 0 && !loading && (
              <div className="no-results">
                <h3>No cars to evaluate</h3>
                {/* <Button variant="primary" onClick={() => navigate("/DealerHome")}>
                  Back to Home
                </Button> */}
              </div>
            )}

            {Object.entries(groupedByYard).map(([yard, yardCars]) => {
              const carCount = yardCars.length;
              const firstFour = yardCars.slice(0, 4);
              const rest = yardCars.slice(4);
              const dummies = Array(Math.max(0, 4 - firstFour.length)).fill().map((_, i) => ({
                id: `dummy-${yard}-${i}`,
                isDummy: true,
                image: dummyImg,
              }));
              const displayCars = [...firstFour, ...dummies, ...rest];

              return (
                <div className="card-slider" key={yard}>
                   <div className="yard-group">
                  <div className="car-card location-card">
                    <div className="location-column">
                      <div className="location-heading">
                        <img src={locCard} alt="Location" className="location-img" />
                        <p className="location-title">{yardCars[0]?.location || yard}</p>
                        <div className="car-img-heading">
                          <ImageWithFallback src={smallcar} alt="Car" className="small-car-icon" />
                          <span className="car-count"> {carCount}</span>
                        </div>
                      </div>
                    </div>

                    <div
                      className="car-grid"
                      ref={(el) => (carGridRefs.current[`mobile-${yard}`] = el)}
                    >
                      <div
                        className="container-map"
                        onClick={() => window.open(getMapUrl(yardMapData[yard]), "_blank")}
                      >
                        <div
                          className="yard-map-container"
                          style={{ pointerEvents: "none" }}
                          dangerouslySetInnerHTML={{
                            __html:
                              buildCleanMapIframe(yardMapData[yard]) ||
                              '<div style="background:#f0f0f0; height:180px; display:flex; align-items:center; justify-content:center; color:#999; font-size:14px; border-radius:8px;">Map not available</div>',
                          }}
                        />
                      </div>
                      {displayCars.map((car, idx) => (
                        <EvaluatorCarCard
                          key={car.id}
                          car={car}
                          onCarSelect={handleUploadPictures}
                          onSlideLeft={() => handleSlideLeft(yard, "mobile")}
                          onSlideRight={() => handleSlideRight(yard, "mobile")}
                          isFourth={idx === 3}
                          hasMoreCars={displayCars.length > 4}
                          index={idx}
                        />
                      ))}
                    </div>
                  </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <UploadModal
        isOpen={isUploadModalOpen}
        onClose={handleCloseModal}
        car={cars.find((c) => c.id === selectedCarId) || {}}
        onSubmitPictures={handleSubmitPictures}
      />
    </div>
    </div>
  );
};

// === MAP UTILS (UNCHANGED) ===
export const buildCleanMapIframe = (iframeHtml) => {
  if (!iframeHtml) return null;
  const srcMatch = iframeHtml.match(/src=["']([^"']+)["']/);
  if (!srcMatch) return iframeHtml;
  const src = srcMatch[1];
  const pbMatch = src.match(/pb=([^&"]+)/);
  if (!pbMatch) return iframeHtml;
  const pb = pbMatch[1];
  const cleanSrc = `https://www.google.com/maps/embed?pb=${pb}&hl=en&output=embed&z=15&maptype=roadmap`;
  return `<iframe src="${cleanSrc}" width="100%" style="border:none;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
};

export const getMapUrl = (iframeHtml) => {
  if (!iframeHtml) return "https://maps.google.com";
  const match = iframeHtml.match(/src=["']([^"']+)["']/);
  return match ? match[1] : "https://maps.google.com";
};